export const TOPIC_KINDS:{kind: string, name: string}[] = [
  {
    kind: 'Artikelart',
    name: $localize`:@@topic-kind-article-type:Artikelart`,
  },
  {
    kind: 'Ausschreibende Einrichtung',
    name: $localize`:@@topic-kind-organizing-institution:Ausschreibende Einrichtung`,
  },
  {
    kind: 'Fachrichtung',
    name: $localize`:@@topic-kind-subject-area:Fachrichtung`,
  },
];
